import Notiflix from "notiflix";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const generateUuid = () => {
  return uuidv4();
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function AirtelProceed() {
  let navigate = useNavigate();
  let router = useQuery();
  console.log(navigate, router);

  // const [user, setUser] = useState({});

  return (
    <>
      <div className="mc-page-container">
        <header className="mc-game-header">
          <img src="images/logoimg.png" alt="" className="mc-logo" />
        </header>
        <section className="mc-section-proceed">
          <div>
            <h3>Welcome</h3>
            {/* <h2>{user ? user?.mobile : ""}</h2> */}
          </div>
          <div className="logo-container">
            <img src="images/wheellogo.png" alt="" />
          </div>

          <div className="btn-container">
            <a
              id="secureDLink"
              style={{ textDecoration: "none", color: "black" }}
              href={`http://ng-airtel-web.upp.st/NAC-NGAIR-TELEN/telenityspin4cashdaily-24-no-70010-web?trfSrc=Golden_Goose&trxId=${generateUuid()}`}
            >
              <button
                className="mc-proceed-btn"
                onClick={() => {
                  Notiflix.Loading.circle();
                }}
              >
                Click to Proceed
              </button>
            </a>
          </div>
        </section>
      </div>
    </>
  );
}
